module.exports = "/static/Images/es/VerySatisfied.png";